import { api } from './api';
import { UserData } from '../types';

export async function getProjectUsers(projectId: string): Promise<UserData[]> {
  const response = await api.get(`admin/projects/${projectId}/users`);
  return response.json();
}
